<template>
  <el-container>
    <el-header style="height: 20px;">
      <span class="company" v-if="currentUser.userType === 1">亲爱的：{{currentUser.person.name}}</span>
      <span class="company" v-if="currentUser.userType === 2">亲爱的：{{currentUser.customer.name}}</span>
      <span class="company" style="margin-left: 10px">当前公司：{{saleOrgName}}</span>
      <el-button class="but3" size="small" @click="changeCompany">点此切换公司</el-button>
      <el-button class="but3" size="small" style="margin-left: -10px" @click="logout">退出登录</el-button>
    </el-header>
    <el-divider class="div_top"></el-divider>
    <el-main class="main">
      <span class="text"><img class="icon_star" src="@/assets/images/icon_star.png" alt=""/>我的收藏</span>
      <el-table :data="favoriteList" style="width: 100%;margin-top: 10px;" border>
        <el-table-column label="商品">
          <template slot-scope="scope">
            <div style="display: inline-block">
<!--              <img class="simple" src="@/assets/images/simple.jpg" style="width: 79px;" alt=""/>-->
              <img class="simple" v-if="scope.row.headUri != null" :src="scope.row.headUri" alt=""/>
              <img class="simple" v-else :src="'https://minio.godaji.com/minio/osp/'+scope.row.goodsCode+'.jpg'" onerror="this.src='https://minio.godaji.com/minio/osp/simple.jpg';this.onerror=null;" style="width: 79px;height: 79px" alt=""/>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="商品名称">
          <template slot-scope="scope">
            <span class="sp4">{{scope.row.goodsName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="代号">
          <template slot-scope="scope">
            <span class="sp4" style="color: rgb(239, 51, 69);font-weight: 600">{{scope.row.goodsAlias}}</span>
          </template>
        </el-table-column>
        <el-table-column label="规格">
          <template slot-scope="scope">
            <span class="sp4">{{scope.row.goodsRule}}</span>
          </template>
        </el-table-column>
        <el-table-column label="存放时间">
          <template slot-scope="scope">
            <span class="sp4">{{scope.row.addDate}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200px">
          <template slot-scope="scope">
            <el-button size="small" type="primary" @click="handleCart(scope.row)">加入购物车</el-button>
            <el-button size="small" type="danger" @click="handleDelete(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>
<script>
import {getFavorites, removeByCode} from "../../../api/system/favorites";
import {saveCart} from "../../../api/system/cart";

export default {
  name: "index",
  data(){
    return{
      currentUser:'',
      saleOrgName:'',
      favoriteList:[]
    }
  },
  mounted() {
    //获取当前用户
    this.currentUser = this.$store.getters.currentUser
    //获取当前销售组织ID
    this.saleOrgId = sessionStorage.getItem("saleOrgId")
    //获取当前销售组织名称
    this.saleOrgName = sessionStorage.getItem("saleOrgName")
    //收藏夹列表
    this.getList()
  },
  methods:{
    changeCompany(){
      this.$confirm('确定要切换公司么？', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({path: '/system/user/company'})
      }).catch(() => {

      });
    },
    // 获取收藏夹列表
    getList() {
      let params = []
      params.push(this.saleOrgId)
      // console.log(params)
      getFavorites(params).then(res =>{
        //初始化数据
        // console.log(res.data)
        this.favoriteList = [];
        for(let i in res.data){
          for(let j in res.data[i].favoritesList) {
            //初始化数据
            let goods = {};
            goods.amount = res.data[i].favoritesList[j].amount;
            goods.goodsAlias = res.data[i].favoritesList[j].goodsAlias;
            goods.goodsCode = res.data[i].favoritesList[j].goodsCode;
            goods.goodsId = res.data[i].favoritesList[j].goodsId;
            goods.goodsName = res.data[i].favoritesList[j].goodsName;
            goods.goodsRule = res.data[i].favoritesList[j].goodsRule;
            goods.logo = res.data[i].favoritesList[j].logo;
            goods.orgSaleId = res.data[i].orgSaleId;
            goods.weight = res.data[i].favoritesList[j].weight;
            goods.goodsSpec = res.data[i].favoritesList[j].goodsSpec;
            goods.addDate = res.data[i].favoritesList[j].addDate;
            goods.headUri = res.data[i].favoritesList[j].headUri;
            goods.baseConversionRate = res.data[i].favoritesList[j].baseConversionRate
            goods.assistUnitId = res.data[i].favoritesList[j].assistUnitId
            goods.assistUnitName = res.data[i].favoritesList[j].assistUnitName
            goods.baseUnitId = res.data[i].favoritesList[j].baseUnitId
            goods.baseUnitName = res.data[i].favoritesList[j].baseUnitName
            this.favoriteList.push(goods);
          }
        }
      });
    },
    handleDelete(index){
      this.$confirm("确定要删除此产品么？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let goods = {};let favorite = [];
        goods.goodsCode = this.favoriteList[index].goodsCode;
        goods.orgSaleId = this.saleOrgId;
        favorite.push(goods)
        // console.log(favorite)
        removeByCode(favorite).then(res=>{
          if (res.code === 200) {
            this.$modal.msgSuccess("删除成功!");
            this.favoriteList.splice(index, 1)
          } else {
            this.$modal.msgError("删除失败，请重试");
          }
        }).catch((e) => {
          console.log(e);
        });

      }).catch(() => {

      });
    },
    handleCart(row) {
      let goods = {}
      goods.goodsId = row.goodsId;
      goods.goodsCode = row.goodsCode;
      goods.goodsName = row.goodsName;
      goods.goodsRule = row.goodsRule;
      goods.goodsAlias = row.goodsAlias;
      goods.goodsSpec = row.goodsSpec;
      goods.logo = row.logo;
      goods.headUri = row.headUri;
      goods.baseConversionRate = row.baseConversionRate
      goods.assistUnitId = row.assistUnitId
      goods.assistUnitName = row.assistUnitName
      goods.baseUnitId = row.baseUnitId
      goods.baseUnitName = row.baseUnitName

      if(goods.baseConversionRate != null){
        goods.amount = 1
        goods.weight = this.floatMul(goods.amount,goods.baseConversionRate)
      } else if(row.goodsSpec !== 0){
        let res = 0
        if(goods.baseUnitName === '公斤'){
          goods.weight = 1000
          res = this.floatDivision(goods.weight,goods.goodsSpec)
        }else{
          goods.weight = 1
          res = this.floatDivision(this.floatMul(goods.weight,1000),goods.goodsSpec)
        }
        if(typeof res === 'number' && res%1 === 0) {
          goods.amount = res
        }else{
          goods.amount = Math.ceil(res)
          if(goods.baseUnitName === '公斤'){
            goods.weight = this.floatMul(goods.amount, goods.goodsSpec)
          }else{
            goods.weight = this.floatDivision(this.floatMul(goods.amount, goods.goodsSpec),1000)
          }
        }
      } else{
        if(goods.baseUnitName === '公斤'){
          goods.weight = 1000;
        }else{
          goods.weight = 1;
        }
        goods.amount = 0;
      }
      goods.orgSaleId = row.orgSaleId;

      let goodsList = [];
      goodsList.push(goods)
      // console.log(goodsList)
      saveCart(goodsList).then(res => {
        if(res.code === 200){
          this.$modal.msgSuccess("加入购物车成功!");
        }else {
          this.$modal.msgSuccess("加入购物车失败，请重试");
        }
      })
    },
    logout() {
      let that = this;
      that.$modal.confirm('是否确认退出小禾订货平台？').then(function() {
        that.$store.dispatch("LogOut").then(() => {
          that.$store.dispatch("ClearMenu");
          that.$router.push({ path: that.redirect || "/login" }).catch(()=>{});
        }).catch(() => {});
      })
    },
    //小数乘法
    floatMul(a, b){
      let m = 0, n = 0,              //记录a，b的小数位数
        d = a + "",                  //字符串化
        e = b + "";
      try {
        m = (d.split(".")[1] || '').length;
      } catch (error) {
        console.log(error)
      }
      try {
        n = (e.split(".")[1] || '').length;
      } catch (error) {
        console.log(error)
      }
      let maxInt = Math.pow(10, m + n); //将数字转换为整数的最大倍数
      return Number(d.replace(".", "")) * Number(e.replace(".", "")) / maxInt;
    },
    //小数除法
    floatDivision(a, b){
      let m = 0, n = 0,              //记录a，b的小数位数
        d = a + "",                  //字符串化
        e = b + "";
      try {
        m = (d.split(".")[1] || '').length;
      } catch (error) {
        console.log(error)
      }
      try {
        n = (e.split(".")[1] || '').length;
      } catch (error) {
        console.log(error)
      }
      let maxInt = Math.pow(10, Math.max(n, m)); //将数字转换为整数的最大倍数
      let aInt = this.floatMul(a, maxInt);
      let bInt = this.floatMul(b, maxInt);
      return aInt / bInt;
    }
  }
}
</script>

<style scoped>
  .main{
    overflow: auto;
    height: 86vh;
    margin-top: -10px;
  }
  .company{
    font-size: 14px;
    color:rgb(143, 143, 143)
  }
  .but1{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
  }
  .sp1{
    color: rgb(239, 51, 69);
    font-weight: bold;
    line-height: 20px;
  }
  .sp2{
    color: rgb(239, 51, 69);
    font-size: 14px;
  }
  .sp3{
    font-weight: bold;
  }
  .sp4{
    color: rgb(143, 143, 143);
  }
  .simple{
    width: 80px;
  }
  .but3{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
    font-weight: 600;
  }
  .div_top{
    margin: 12px 0;
  }
  .icon_star{
    width: 22px;
    height: 22px;
    display: flex;
    margin-top: 2px;
    margin-right: 10px;
  }
  .text{
    display: flex;
    color: rgb(239, 51, 69);
    font-size: 20px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: left;
  }
  .el-step.is-simple >>> .el-step__title{
    font-size: 14px;
  }
</style>
